import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductsStoreService } from 'src/app/modules/evc-small-biz/stores/products-store.service';
import { SmallBizStoreService } from 'src/app/modules/evc-small-biz/stores/small-biz-store.service';
import { ChargingCardInputMapper } from './charging-card-input.mapper';
import { ChargingCardInputModel } from './charging-card-input.model';

@Injectable()
export class ChargingCardInputService {
  constructor(
    private mapper: ChargingCardInputMapper,
    private productsStoreService: ProductsStoreService,
    private store: SmallBizStoreService
  ) {}

  public getModel(): ChargingCardInputModel {
    return this.mapper.map();
  }

  public getValue(): number {
    return this.store.model.chargeCardsAmount || 0;
  }

  public getUnitPrice(): Observable<number> {
    return this.productsStoreService.card$.pipe(map((card) => parseInt(card.price, 10)));
  }
}
